import { render } from "./ListeComposition.vue?vue&type=template&id=3673847b&scoped=true&ts=true"
import script from "./ListeComposition.vue?vue&type=script&lang=ts"
export * from "./ListeComposition.vue?vue&type=script&lang=ts"

import "./ListeComposition.vue?vue&type=style&index=0&id=3673847b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3673847b"]])

export default __exports__